import React, { useState } from "react";
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import axios from 'axios';
import Swal from '../../node_modules/sweetalert2/dist/sweetalert2';
import LocationContent from './ModalContent/LocationContent'       
import { ADD_LOCATION_URL} from '../constant'; 
import { addLocationFormValidation} from '../validation/Validation'; 

export default function PopupModal({passId,locType,setValue,addValue,toSetValue,title,handleResetAddValue}) {
    const [visible, setVisible] = useState(false);
    const [locationValue, setLocationValue] = useState({});
    const [loading, setLoading] = useState(false);
    const [errors,setErrors] = useState({});


   

        const sendForm =async (e)=>{
            e.preventDefault();
           
            
            const isValid =  addLocationFormValidation(addValue); 
            console.log(addValue);
            setErrors(isValid);
            //return false;
            if(Object.keys(isValid).length === 0){
            try {
                setLoading(true);
                if(passId){
                const response = await axios.post(ADD_LOCATION_URL, addValue);
                if (response.data.status === '200') {
                    toSetValue(true);
                    setLoading(false);
                    setVisible(false);
                    Swal.fire({
                        title: 'Success!',
                        text: response.data.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                      });
                    setLocationValue({});
                    handleResetAddValue();
                } else {
                    setLoading(false);
                    setVisible(false);
                    toSetValue(false);
                    handleResetAddValue();
                    Swal.fire({
                        title: 'Error!',
                        text: response.data.message,
                        icon: 'Error',
                        confirmButtonText: 'OK',
                      });
                }
            }else{
                setLoading(false);
                setVisible(false);
                toSetValue(false);
                handleResetAddValue();
                Swal.fire({
                    title: 'Error!',
                    text: "Please select passenger ",
                    icon: 'Error',
                    confirmButtonText: 'OK',
                  });
            }
            } catch (error) {
                setLoading(false);
                console.error("Error logging in:", error);
            }
        }
        }


    const headerElement = (
        <div className="inline-flex align-items-center justify-content-center gap-2">
            <span className="font-bold white-space-nowrap">{title}</span>
        </div>
    );

    const footerContent = (
        <div>
            <Button  label="Save" icon="pi pi-check" loading={loading} onClick={sendForm}   autoFocus />
        </div>
    );

    return (
        <div className="card flex justify-content-center">
            <Button label="Add Location"  type="button" onClick={() => setVisible(true)} />
            <Dialog visible={visible} modal header={headerElement} footer={footerContent} style={{ width: '50rem' }} onHide={() => {if (!visible) return; setVisible(false); }}>
               <LocationContent  setLocationValue={setValue} passId={passId} locType={locType} setErrors={setErrors} errors={errors} />
            </Dialog>
          
        </div>
    )
}